import React from 'react';

const MapToComponent = function ({map, defaultComponent, mapKey, children, ...rest}) {
  const compData = map.find(el => el.keyMask ? (new RegExp(el.keyMask)).test(mapKey) : (el.key === mapKey))
  const MappedComponent = compData?.component || defaultComponent

  return (<MappedComponent {...rest}>{children}</MappedComponent>)
}

export default MapToComponent
